var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPercent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeOpacity: 0.7,
  strokeWidth: 2,
  d: "M4.223 19.779 19.779 4.222"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6.502,
  cy: 6.502,
  r: 2.5,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeOpacity: 0.7,
  strokeWidth: 2,
  transform: "rotate(45 6.502 6.502)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.499,
  cy: 17.499,
  r: 2.5,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeOpacity: 0.7,
  strokeWidth: 2,
  transform: "rotate(45 17.499 17.499)"
})));
SvgPercent.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgPercent);
export default ForwardRef;